import { generateCheckoutItemsGA4 } from './ga_generate_items';

export const checkoutEventsUA = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'checkoutStep') {
    const { step, products } = options;
    window.dataLayer.push({
      event,
      ecommerce: {
        currencyCode: 'GBP',
        checkout: {
          actionField: { step },
          products: products.map(
            ({ brand, category, description, id, goods, stepId }) => ({
              id,
              brand,
              'id-variant': stepId,
              name: description,
              category,
              price: parseFloat(goods),
              quantity: 1,
            }),
          ),
        },
      },
    });
  }

  if (event === 'deliveryAddress') {
    const { addressOption } = options;
    window.dataLayer.push({
      event,
      option: addressOption,
    });
  }

  if (event === 'deliveryOptions') {
    const { day, description, price } = options;
    window.dataLayer.push({
      event,
      day,
      description,
      price,
    });
  }

  if (event === 'purchase') {
    const {
      collectionTotal,
      orderId,
      orderTotal,
      orderDeliveryServiceCost,
      orderItems,
      orderTax,
      accountType,
      coupon,
    } = options;

    window.dataLayer.push({
      event,
      ecommerce: {
        currencyCode: 'GBP',
        accountType,
        purchaseType: orderItems.length ? 'AddressDelivery' : 'Split',
        addressDeliveryTotal: orderTotal,
        clickCollectTotal: collectionTotal,
      },
      purchase: {
        actionField: {
          id: orderId,
          revenue: orderTotal,
          tax: orderTax,
          shipping: orderDeliveryServiceCost,
          coupon,
        },
        products: orderItems,
      },
    });
  }
};

export const checkoutEventsGA4 = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'begin_checkout_ga4') {
    const { products } = options;
    window.dataLayer.push({
      event,
      ecommerce: {
        items: generateCheckoutItemsGA4(products),
      },
    });
  }

  if (event === 'add_address_info_ga4') {
    const { value, addressOption, products } = options;
    window.dataLayer.push({
      event,
      ecommerce: {
        currency: 'GBP',
        value,
        address_option: addressOption,
        items: generateCheckoutItemsGA4(products),
      },
    });
  }

  if (event === 'add_shipping_info_ga4') {
    const { value, addressMode, day, description, price, products } = options;

    window.dataLayer.push({
      event,
      ecommerce: {
        currency: 'GBP',
        value,
        address_option: addressMode,
        shipping_tier: `${day} - ${description} - ${price}`,
        day,
        description,
        price,
        items: generateCheckoutItemsGA4(products),
      },
    });
  }

  if (event === 'purchase_ga4') {
    const {
      collectionTotal,
      storeDeliveryTotal,
      orderId,
      orderTotal,
      orderDeliveryServiceCost,
      orderItems,
      collectionItems,
      orderTax,
      accountType,
      coupon,
    } = options;

    // TO DO: Add extra properties in Phase 2
    window.dataLayer.push({
      event,
      ecommerce: {
        // affiliation: "Durham",
        id: orderId,
        currency: 'GBP',
        value: orderTotal,
        tax: orderTax,
        shipping: orderDeliveryServiceCost,
        // address_option: 'Invoice address',
        // shipping_tier: 'Next day - Anytime',
        // payment_type: 'Account',
        account_type: accountType,
        order_type: orderItems?.length
          ? 'AddressDelivery'
          : collectionItems?.length
          ? 'ClickCollect'
          : 'Split',
        StoreDeliveryTotal: storeDeliveryTotal,
        addressDeliveryTotal: orderTotal,
        clickCollectTotal: collectionTotal,
        coupon,
        items: generateCheckoutItemsGA4(orderItems || collectionItems),
      },
    });
  }
};
